import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterOutlet, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonService } from '../../../Model/Common/common.service';
import { LetterDocumentService } from '../../../Model/LetterDocument/letter-document.service';
import { LetterTemplateFormComponent } from '../../LetterTemplate/letter-template-form/letter-template-form.component';
import { FormsModule } from '@angular/forms';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-letter-template-upload',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterOutlet, RouterModule, DataTablesModule, LoaderComponent],
  templateUrl: './letter-template-upload.component.html',
  styleUrl: './letter-template-upload.component.scss'
})
export class LetterTemplateUploadComponent {
  isDisabled: boolean = false;
  user = [] as any;
  TableDatas: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private modalService: NgbModal,
    protected common: CommonService,
    private letterDocument: LetterDocumentService,
    private toast: ToastService,
    private utility: UtilityService,
    private session: SessionService,
  ) {
    this.user = this.session.GetUserDetails();
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESSLetterTemplateMasterSelect();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESSLetterTemplateMasterSelect() {
    this.isDisabled = true;
    this.letterDocument.ESSLetterTemplateMasterSelect({ ESS_LetterTemplateMasterID: 0, SelectType: 2 }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = Object.values(response.Table);
        } else {
          this.TableDatas = Object.values([]);
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Check(event: any, i: number, IsAll = false) {
    if (IsAll) {
      this.TableDatas.map((e: any) => e.IsCheck = event.target.checked);
    } else {
      this.TableDatas[i].IsCheck = event.target.checked;
    }
  }

  upload(event: any, Folder: any, index: number) {
    if (this.common.PageRight.IsAdd) {
      try {
        if (true || (event.currentTarget.accept).includes(event.target.files[0].type.split('/')[1])) {
          const file = event.target.files[0];
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => {
            this.UploadServices(Folder, reader.result, index);
            event.target.value = null;
          };
        } else {
          this.toast.show({ message: 'selected file not allow, allow file only ' + event.currentTarget.accept, type: toastTypeEnum.danger });
          event.target.value = null;
        }
      } catch (e) { }
    } else {
      event.target.value = null;
    }

  }

  UploadServices(Folder: string, Base64: any, index: number) {
    this.isDisabled = true;
    this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': Folder, 'CompanyCode': this.user.CompanyCode, 'FileBase64': Base64 }).subscribe((response: any) => {
      if (response.FileName != "" && response.FileName != null) {
        this.ESS_LetterTemplate_UploadFile(index, response.FileName);
      } else {
        this.toast.show({ message: 'Image not uploaded', type: toastTypeEnum.warning });
      }
      this.isDisabled = false;
    }, (error) => {
      this.isDisabled = false;
    });
  }

  ESS_LetterTemplate_UploadFile(index: number, LetterFileName: string) {
    this.isDisabled = true;
    this.letterDocument.ESS_LetterTemplate_UploadFile({ 'ESS_LetterTemplateMasterID': this.TableDatas[index]['ESS_LetterTemplateMasterID'], 'LetterFileName': LetterFileName }).subscribe((response: any) => {
      if (response.Error_Code == '537') {
        this.TableDatas[index]['LetterFileName'] = LetterFileName;
        const modalRef = this.modalService.open(AlertSuccessComponent, {
          size: 'md',
          backdrop: 'static',
          centered: true,
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = response.Error_Message;
        modalRef.result.then((result: any) => { });
      }
      else {
        const modalRef = this.modalService.open(AlertWarningComponent, {
          size: 'md',
          backdrop: 'static',
          centered: true,
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = response.Error_Message;
        modalRef.result.then((result: any) => { });
      }
      this.isDisabled = false;
    }, (error) => {
      this.isDisabled = false;
    });
  }

  GetLink(index: number) {
    return this.common.CompanyParameterValue.HTTPSDownloadLink + '/LetterTemplate/' + this.TableDatas[index]['LetterCode'] + '/' + this.TableDatas[index]['LetterFileName']
  }
}
